module.exports = __webpack_public_path__ + "fromGroomToFather-jp-w.e1b5522c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToFather-jp-w.jpg
// module id = FtdW
// module chunks = 0